export default __webpack_public_path__ + "static/css/style.50f8f322.css";